<script lang="ts">
	//Services
	import { format } from '../../../../../services/i18n';
	//Helpers
	import { formatSnakeCaseToTitle } from '../../../../../helpers/utilities';
	//Design system components
	import { Container, Radio, Text } from '@Shelly/shelly-design-system';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	import SettingGuide from '../../../SettingGuide.svelte';
	//Types
	import type { InputOutputOptions } from './input_output_types';

	export let typeValue: string, initialStateValue: string, initialStateOptions: InputOutputOptions;

	const setInitialState = async (_initial_state_value) => {
		initialStateValue = _initial_state_value;
	};

	const isOptionUnavailable = (option: InputOutputOptions[string]) =>
		option.type !== typeValue && option.type !== 'any';

	$: {
		const selected = initialStateOptions[initialStateValue];
		if (selected && isOptionUnavailable(selected)) {
			const firstAvailable = Object.entries(initialStateOptions).find(
				([, option]) => !isOptionUnavailable(option),
			);
			if (firstAvailable) {
				initialStateValue = firstAvailable[0];
			}
		}
	}
</script>

{#if $showNewLayout}
	<div>
		<Text class="text-bold mb-xs">
			{formatSnakeCaseToTitle(
				$format('action_on_power_on_default_label', {
					default: 'Action power on default',
				}),
			)}
		</Text>
		<SettingGuide
			text={$format('settings_guide_action_on_power_on', {
				default:
					'Choose what this device does when power comes back after a cut — turn on, stay off, or restore the last state.',
			})}
		/>
		{#each Object.entries(initialStateOptions) as option (option[0])}
			{#if !isOptionUnavailable(option[1])}
				<Radio
					size="m"
					bind:selected={initialStateValue}
					value={option[0]}
					class="mb-xs"
					on:click={() => setInitialState(option[0])}
					id={`radio-initial-state-output-${option[0]}`}
					info={option[1]?.description}
				>
					{option[1]?.title}
				</Radio>
			{/if}
		{/each}
	</div>
{:else}
	<Container type="base" class="mb-s" padding="xs">
		<Text class="text-bold mb-s">
			{formatSnakeCaseToTitle(
				$format('action_on_power_on_default_label', {
					default: 'Action power on default',
				}),
			)}
		</Text>
		<SettingGuide
			text={$format('settings_guide_action_on_power_on', {
				default:
					'Choose what this device does when power comes back after a cut — turn on, stay off, or restore the last state.',
			})}
		/>
		{#each Object.entries(initialStateOptions) as option (option[0])}
			<Radio
				size="m"
				bind:selected={initialStateValue}
				value={option[0]}
				disabled={isOptionUnavailable(option[1])}
				on:click={() => setInitialState(option[0])}
				id="radio-gtjaiev"
			>
				{option[1].text}
			</Radio>
		{/each}
	</Container>
{/if}
